import { PassesList } from 'booking/components';
import { useGetStoreQuery } from 'drycut-graphql';
import { useNavigate, useParams } from 'react-router';
import { Loader } from 'ui-components';
import { useDocumentTitle } from 'usehooks-ts';

export function Passes(): React.ReactNode {
  useDocumentTitle('DRYCUT - DRYPASS');

  const navigate = useNavigate();
  const { slug } = useParams() as { slug: string };
  const { data, loading } = useGetStoreQuery({ variables: { slug } });

  if (loading) {
    return <Loader />;
  }

  if (!data?.store || !data.store.active) {
    navigate('/not-found');
    return null;
  }

  return <PassesList storeSlug={slug} />;
}
